
export class ItemDualPickListModel{


  left:boolean;
  right:boolean;
constructor() {
  }


}

function ItemDualPickListModel_tsickle_Closure_declarations() {
/** @type {?} */
ItemDualPickListModel.prototype.left;
/** @type {?} */
ItemDualPickListModel.prototype.right;
}

